import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router, RouterForm, RouterService} from "../../../../../../../services/back/router.service";
import {FormControl} from "@angular/forms";
import {distinctUntilChanged, finalize, Observable, of, Subscription, switchMap, takeWhile, tap} from "rxjs";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {SnackbarService} from "../../../../../../../services/front/snackbar.service";
import {RouterDetailData, RouterDetailService} from "../../../../../../../services/front/router-detail.service";
import {filter, map} from "rxjs/operators";
import {MiniButtonModule} from "../../../../../../global/button/mini-button/mini-button.module";
import {DesignSystemModule} from "../../../../../../design-system/design-system.module";
import {NgForOf, NgIf} from "@angular/common";
import {ButtonWidgetComponent} from "../../../../../../design-system/button-widget/button-widget.component";

@Component({
  selector: 'app-router-internet-connection',
  standalone: true,
	imports: [
		TranslateModule,
		MiniButtonModule,
		DesignSystemModule,
		NgIf,
		ButtonWidgetComponent
	],
  templateUrl: './router-internet-connection.component.html',
  styleUrl: './router-internet-connection.component.scss'
})
export class RouterInternetConnectionComponent implements OnInit, OnDestroy{
	@Input() router: Router;

	tenantId: string;
	_saving: boolean;
	isEditor: boolean;

	formControl: FormControl<string | null>;

	hovered: boolean = false;

	subscription: Subscription = new Subscription();

	constructor(private routerService: RouterService,
				private translateService: TranslateService,
				private snackBarService: SnackbarService,
				private routerDetailService: RouterDetailService) {
	}

	ngOnInit() {
		this.subscription.add(this.routerDetailService.getRouterDetailDataChanges()
			.pipe(tap(data => this.setRouterDetailData(data)))
			.subscribe());

		this.buildForm();
	}

	setRouterDetailData(data: RouterDetailData): void {
		this.tenantId = data.tenantId;
		this.isEditor = data.isEditor;
	}

	buildForm(): void {
		this.formControl = new FormControl<string | null>(this.router.internetConnection === true ? 'yes' : this.router.internetConnection === false ? 'no' : null);

		this.subscription.add(this.formControl.valueChanges.pipe(distinctUntilChanged())
			.subscribe(() => this.updateRouterInformation()));
	}

	updateRouterInformation(): void {
		this.switchSaving()
			.pipe(
				filter(() => this.hasInformationChanged() && this.formControl.valid),
				map(() => this.buildRouterForm()),
				switchMap(form => this.routerService.update(this.tenantId, this.router.id, form)),
				tap((updateSucceeded) => this.displayUpdatedSucceed(updateSucceeded)),
				tap(() => this.routerDetailService.refreshRouter()),
				takeWhile(() => !this.subscription.closed),
				finalize(() => this.switchSaving()))
			.subscribe();
	}

	hasInformationChanged(): boolean {
		return this.router.internetConnection !== (this.formControl.value);
	}

	buildRouterForm(): RouterForm {
		return {
			name: this.router.name,
			type: this.router.type,
			ipAddress: this.router.ipAddress || undefined,
			location: this.router.location || undefined,
			description: this.router.description || undefined,
			internetConnection: this.formControl.value === 'yes' ? true : this.formControl.value === 'no' ? false : undefined,
		};
	}

	displayUpdatedSucceed(updateSucceed: boolean): void {
		if (updateSucceed) {
			this.snackBarService.show(this.translateService.instant('page.application.detail.update.success'));
		} else {
			this.snackBarService.show(this.translateService.instant('page.application.detail.update.fail'), 'danger-snack');
		}
	}

	switchSaving(): Observable<{}> {
		this._saving = !this._saving;
		return of({});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}
}
